import { gql, type TypedDocumentNode } from '@apollo/client';
import type {
  AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables,
  AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables,
} from '@/generated/campaign-audit-content';

export type CampaignAuditContent = NonNullable<AdminCpmCampaignContentQuery['adminCpmCampaignContent']>;
export const ADMIN_CPM_CAMPAIGN_CONTENT = gql`
  query AdminCpmCampaignContent($campaignId: ID!) {
    adminCpmCampaignContent(campaignId: $campaignId) {
      id name description rules_allowed rules_forbidden rules_attention rules_warning
      required_hashtags required_mention banner_url logo_url
      content_locked editing_locked_reason scheduled_activation_at
    }
  }
` as TypedDocumentNode<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>;
export const ADMIN_UPDATE_CPM_CAMPAIGN_CONTENT = gql`
  mutation AdminUpdateCpmCampaignContent($campaignId: ID!, $input: CampaignAuditContentInput!) {
    adminUpdateCpmCampaignContent(campaignId: $campaignId, input: $input) {
      id name description rules_allowed rules_forbidden rules_attention rules_warning
      required_hashtags required_mention banner_url logo_url
      content_locked editing_locked_reason scheduled_activation_at
    }
  }
` as TypedDocumentNode<AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables>;
